module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "user-menu"
  }, [(_vm.show) ? _c('div', {
    staticClass: "user-menu__overlay overlay",
    on: {
      "click": _vm.hide
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "popover"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "user-menu__popover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewSettings($event)
      }
    }
  }, [_vm._v("Instellingen")]), (_vm.isAdmin) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleAppAdmin($event)
      }
    }
  }, [_vm._v(_vm._s(this.isAdminActive ? 'Naar app' : 'Naar admin'))]) : _vm._e(), _c('router-link', {
    attrs: {
      "to": _vm.logout.to
    }
  }, [_vm._v(_vm._s(_vm.logout.text))])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fac61964","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/UserMenu.vue
// module id = 3u6l
// module chunks = 0 1